import { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ContainerService from '../../../../services/ContainerService';
import { Input, Button, Table, Card, Modal, Breadcrumbs } from '../../../../components/UI/ComponentsUI'
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { showMessageToastCustom, translate } from '../../../../utils/util';

const SpawningFull = (props) => {
    const [container, setContainer] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const [filter, setFilter] = useState({
        name: "",
    });

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const searchContainer = () => {
        if (validateInputsRequired('getChange')) {
            props.getContainer(filter, (response) => {
                if (response) {
                    setContainer(response || {})
                } else {
                    setContainer({})
                    showMessageToastCustom(translate('warning', 'general'), "Container não encontrado", 3000, 'mdi mdi-alert-circle-outline red-text');
                }
            })
        }
    }

    const onConfirm = () => {
        props.sendContainerSpawning(container, () => {
            showMessageToastCustom(translate('info', 'general'), 'Container desovado com sucesso!', 3000, 'mdi mdi-checkbox-marked-circle-outline green-text');

            setContainer({})
            setFilter({})
        })
    }

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: translate('container:spawning:menu.total-spawing') }} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container">
                    <Card>
                        <div id="getChange" className="col s12">
                            <div className="row" style={{ padding: '10px' }}>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        id="name"
                                        name='name'
                                        maxLength="11"
                                        label="Num. Container"
                                        required
                                        type="text"
                                        value={filter?.name || ''}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button full="true"
                                text="Buscar"
                                onClick={searchContainer} />
                        </div>
                        {
                            container?.id && <Table
                                totalPages={0}
                                onClickRow={() => setOpenModal(true)}
                                disablePaged={true}
                                col={[
                                    {
                                        field: 'name',
                                        header: 'Container',
                                        align: 'left',
                                    },
                                    {
                                        field: 'statusDescription',
                                        header: 'Status',
                                        align: 'left',
                                    },
                                    {
                                        field: 'mvmNumber',
                                        header: 'Nº Mvm',
                                        align: 'left',
                                    },
                                    {
                                        field: 'journey',
                                        header: 'Viagem',
                                        align: 'left',
                                    }
                                ]}
                                data={[container]}
                            />
                        }
                    </Card>
                    <Modal
                        maxHeight='auto'
                        open={openModal}
                        dismissible={false}
                        id="modalContainerAlertDesova"
                        btnCancel={translate('cancel', 'general')}
                        onConfirm={() => {
                            onConfirm();
                            setOpenModal(false)
                        }}
                        onCancel={() => {
                            setOpenModal(false);
                        }}
                        closeModal={() => {
                            setOpenModal(false);
                        }}
                        title="Atenção"
                        content="Deseja desovar todos os materiais do container?"
                    />
                </div>
            </div>
        </div>

    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getContainer: (filter, callback) => {
            dispatch(ContainerService.getContainer(filter, callback));
        },
        sendContainerSpawning: (data, callback) => {
            dispatch(ContainerService.sendContainerSpawning(data, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SpawningFull));
